import styled from 'styled-components';

export default styled.div`
  padding: 0.5rem;
  border-radius: 3px;
  border: 1px solid #2764ae;
  background-color: white;
  box-shadow: 1px 1px 5px 5px rgba(0, 0, 0, 0.05);
`;
